import { createDeferredI18n } from "#/shared/composables/useI18n";
import fallbackMessages from "#/shared/i18n/frontend.quantum_select.json";
import { RemoteStatus } from "#ce/components/SpQuantumSelect/composables/useQuantumSelectRemote";

export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "quantum_select", fallbackMessages });

/** Remote status text, shown and announced. `count` is the number of loaded rows. */
export function remoteStatusText(state, minimum, count) {
  const t = i18n.global.t;

  if (state.status === RemoteStatus.TOO_SHORT) {
    const remaining = Math.max(1, minimum - [...state.query].length);

    return t("type_more", { count: remaining }, remaining);
  }

  if ([RemoteStatus.DEBOUNCING, RemoteStatus.LOADING].includes(state.status)) {
    return t("loading");
  }

  if (state.status === RemoteStatus.LOADING_MORE) {
    return t("loading_more");
  }

  if (state.status === RemoteStatus.ERROR) {
    return t("error");
  }

  if (state.status === RemoteStatus.EMPTY) {
    return t("empty");
  }

  if (state.status === RemoteStatus.READY) {
    return t("loaded", { count }, count);
  }

  return "";
}
